import React from 'react';
export function RemoveCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01 2C6.49 2 2.01 6.48 2 11.98 2 17.5 6.47 21.99 11.99 22c5.51 0 9.99-4.48 10-9.98C21.99 6.5 17.52 2.01 12 2h.01zM15 13H9c-.55-.01-1-.45-1-1.01S8.45 11 9 11h6c.55.01 1 .45 1 1.01s-.45.99-1 .99z"
  }));
}